import styled from "styled-components";

export const Preview = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 20px;
  color: #040222;
  box-sizing: border-box;
`;

export const HeroIcon = styled.img<{ $isDesktop: boolean }>`
  width: 80px;
  height: 80px;
  object-fit: contain;
`;

export const Title = styled.h1<{ $isDesktop: boolean }>`
  margin: 0;
  color: #040222;
  font-size: ${({ $isDesktop }) => ($isDesktop ? "24px" : "20px")};
  font-weight: 600;
  line-height: ${({ $isDesktop }) => ($isDesktop ? "32px" : "28px")};
  letter-spacing: 0;
`;

export const Plans = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const Plan = styled.article<{ $selected?: boolean }>`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border: 1px solid ${({ $selected }) => ($selected ? "#b191ed" : "#e7e7f0")};
  border-radius: 24px;
  background: #fff;
  box-sizing: border-box;
`;

export const PlanHead = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
`;

export const PlanName = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
`;

export const Badge = styled.span<{ $variant: "neutral" | "upgrade" }>`
  display: inline-flex;
  align-items: center;
  min-height: 16px;
  padding: 0 8px;
  border-radius: 8px;
  color: ${({ $variant }) => ($variant === "upgrade" ? "#fff" : "#040222")};
  background: ${({ $variant }) =>
    $variant === "upgrade"
      ? "linear-gradient(266deg, #f66969 10.35%, #743ddc 106.34%)"
      : "#f0f0f6"};
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
`;

export const PlanTitle = styled.h2`
  margin: 0;
  color: #5920c5;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
`;

export const PriceBlock = styled.div`
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
`;

export const Premium = styled.strong`
  color: #040222;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  white-space: nowrap;
`;

export const PriceNudge = styled.span`
  display: inline-flex;
  justify-content: flex-end;
  min-width: 88px;
  padding: 4px 0 4px 8px;
  border-radius: 49px;
  color: #0a562a;
  background: linear-gradient(
    94deg,
    rgba(74, 222, 128, 0.32) 0.48%,
    rgba(74, 222, 128, 0) 89.37%
  );
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
  white-space: nowrap;
  box-sizing: border-box;
`;

export const Benefits = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Benefit = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  color: #36354c;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`;

export const BenefitIcon = styled.img`
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  margin-top: 1px;
`;

export const BenefitText = styled.span`
  min-width: 0;
`;

export const Highlight = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border-radius: 9px;
  background: rgba(239, 233, 251, 0.5);
  box-sizing: border-box;
`;

export const HighlightTitle = styled.h3<{ $isDesktop: boolean }>`
  margin: 0;
  color: ${({ $isDesktop }) => ($isDesktop ? "#36354c" : "#040222")};
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
`;

export const SelectButton = styled.button`
  width: 100%;
  min-height: 48px;
  border: 1px solid #040222;
  border-radius: 8px;
  background: #fff;
  color: #040222;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;
`;

export const ExploreButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 52px;
  padding: 16px;
  border: 1px solid #e7e7f0;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  box-sizing: border-box;
`;

export const ExploreTitle = styled.span`
  color: #040222;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
`;

export const ExploreLabel = styled.strong`
  color: #1b73e8;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
`;
